import {
    DEFAULT_REDIRECT,
    CHRYSLER_REDIRECT,
    DODGE_REDIRECT,
    JEEP_REDIRECT,
    RAM_REDIRECT,
    FIAT_REDIRECT,
    ALFA_REDIRECT,
} from '../../constants';

export const getRedirectUrl = (brand: string) => {
    switch (brand) {
        case 'chrysler':
            return CHRYSLER_REDIRECT;
        case 'dodge':
            return DODGE_REDIRECT;
        case 'jeep':
            return JEEP_REDIRECT;
        case 'ram':
            return RAM_REDIRECT;
        case 'fiat':
            return FIAT_REDIRECT;
        case 'alfa':
            return ALFA_REDIRECT;
        default:
            return DEFAULT_REDIRECT;
    }
};
